import { render, staticRenderFns } from "./resources-editor-simple.vue?vue&type=template&id=07e547b6"
import script from "./resources-editor-simple.vue?vue&type=script&lang=js"
export * from "./resources-editor-simple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports